import request from '@/plugin/axios'
// 查询提成列表信息
export function api(params) {
  console.log(params);
  return request({
    url: '',
    method: 'get',
    params: params
  })
}

// 保存提成列表信息
export function apicun(data) {
  console.log(data);
  return request({
    url: '',
    method: 'post',
    data: data
  })
}
// 导出
export function apichu(data) {
  console.log(data);
  return request({
    url: '',
    method: 'post',
    data: data
  })
}
// 审核提成列表信息
// 导出
export function apishen(data) {
  console.log(data);
  return request({
    url: '',
    method: 'post',
    data: data
  })
}